import { SearchCriteriaItems } from '../../components';

export const searchCriterias: SearchCriteriaItems[] = [
  {
    id: 'searchKeyword',
    name: 'Order Number',
    placeholder: 'Search by Order Number',
    searchResults: [],
    onSearch: () => {},
  },
  {
    id: 'invoiceId',
    name: 'Invoices',
    placeholder: 'Search by invoice number',
    searchResults: [],
    onSearch: () => {},
  },
  {
    id: 'customerId',
    name: 'Customer',
    placeholder: 'Search by customer',
    searchResults: [],
    onSearch: () => {},
  },
  {
    id: 'userId',
    name: 'Team Member',
    placeholder: 'Search by team member',
    searchResults: [],
    onSearch: () => {},
  },
  {
    id: 'productVariantIds',
    name: 'Product',
    placeholder: 'Search by product',
    searchResults: [],
    onSearch: () => {},
  },
];

export const searchCriteriasScreenMap: Record<string, string[]> = {
  orders: ['searchKeyword', 'customerId', 'productVariantIds', 'userId'],
  invoices: ['invoiceId', 'customerId'],
};

export const getSearchCriterias = (
  screen: keyof typeof searchCriteriasScreenMap
) => {
  return searchCriterias.filter((criteria) =>
    searchCriteriasScreenMap[screen].includes(
      criteria.id as keyof typeof searchCriteriasScreenMap
    )
  );
};
